import axios from "axios";
import store from "../../../redux/store";
import { setIsLoading } from "../../../redux/loader/action";
import { setCurrentUser } from "../../../redux/game/action";

const removeUsersFromTeam = async ({ team_code, user_id }) => {
  const storeState = store.getStore().getState();
  const currentUser = storeState.gameReducer.currentUser;
  try {
    store.dispatch(setIsLoading(true));
    let url = process.env.REACT_APP_REMOVE_PLAYER_MYTEAM;
    const res = await axios.post(url, {
      promoCode: team_code,
      userId: user_id,
    });
    console.log("resresres: ", res);
    if (res.data.message == "player removed sucessfully") {
      const new_team = {
        ...currentUser.team,
        users: currentUser.team.users.filter(
          (item) => (item.Username || item.user_id) != user_id
        ),
      };
      store.dispatch(setCurrentUser({ ...currentUser, team: new_team }));
      store.dispatch(setIsLoading(false));
    }
  } catch (error) {
    store.dispatch(setIsLoading(false));
  }
};

export default removeUsersFromTeam;
